export const listEmployeeNameSpec = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Employee Name',
    name: 'EMPLOYEE_NAME',
    type: 'String',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Employee Job',
    name: 'EMPLOYEE_JOB',
    type: 'String',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Employee Username',
    name: 'employeeUsername',
    type: 'String',
  },
]
